const joditButtons = [
    'source',
    '|',
    'bold',
    'underline',
    'italic',
    '|',
    'ul',
    'ol',
    '|',
    'outdent',
    'indent',
    '|',
    'brush',
    // 'paragraph',
    '|',
    'link',
]

export default {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
    colorPickerDefaultTab: 'color',
    buttons: joditButtons,
    buttonsMD: joditButtons,
    buttonsSM: joditButtons,
    buttonsSX: joditButtons,
}
